import { render, staticRenderFns } from "./BnftWishlists.vue?vue&type=template&id=0bf07138&scoped=true&"
import script from "./BnftWishlists.vue?vue&type=script&lang=js&"
export * from "./BnftWishlists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf07138",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VContainer,VDataTable,VImg,VOverlay})
